import { createTheme } from '@mui/material/styles';
import '@fontsource/inter';  // Imports Inter font

const theme = createTheme({
  typography: {
    fontFamily: 'Inter, sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: 'var(--colors-dark-orange)', // or your custom color
          },
        },
      },
    },
  },
});

export default theme;